import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import "./App.css";

import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState } from "react";

import LoginPage from "./components/login";
import PageLayout from "./components/dashboard";
import MainLayout from "./components/layout/MainLayout";
import useAuth from "./hooks/useAuth";

function App() {
  const isMobileView = window.innerWidth <= 768;
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobileView);
  const loggedIn = useAuth();
  const location = useLocation();

  return (
    <div className="App">
      <MainLayout isMobileView={isMobileView}>
        <Routes>
          <Route path="/" element={loggedIn ? <Navigate to="/home" replace /> : <LoginPage />} />
          <Route
            path="/home"
            element={loggedIn ? <PageLayout location={location} /> : <Navigate to="/" replace />}
          />
          <Route
            path="/home/:action"
            element={loggedIn ? <PageLayout location={location} /> : <Navigate to="/" replace />}
          />
        </Routes>
      </MainLayout>
    </div>
  );
}

export default App;
